import { typeWireOf } from "@typewirets/core";
import { ASTSerializer, FormulaParser } from "./formula-parser";

export const ASTSerializerWire = typeWireOf({
  token: "AstSerializer",
  createWith() {
    return new ASTSerializer();
  },
});

export const FormulaParserWire = typeWireOf({
  token: "FormulaParser",
  createWith() {
    return new FormulaParser();
  },
});
